// extracted by mini-css-extract-plugin
module.exports = {"Modal":"📚4-7-02f64r"};